import React from "react";
import {Link} from "react-router-dom";

export default function ({customer}) {
  return (
    <div className="col-xxl-6 pt-5">
      <div className="card card-flush py-4 flex-row-fluid">
        <div className="card-header">
          <div className="card-title">
            <h2>Customer Details</h2>
          </div>
        </div>
        <div className="card-body pt-0">
          <div className="table-responsive">
            <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
              <tbody className="fw-bold text-gray-600">
              <tr>
                <td className="text-muted">
                  <div className="d-flex align-items-center">
                    Customer
                  </div>
                </td>
                <td className="fw-bolder text-end">
                  <div className="d-flex align-items-center justify-content-end">
                    <Link to={`/customers/${customer.id}`}
                          className="text-gray-600 text-hover-primary"
                    >
                      {customer?.full_name}
                    </Link>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="text-muted">
                  <div className="d-flex align-items-center">
                    Email
                  </div>
                </td>
                <td className="fw-bolder text-end">
                  {customer?.email}
                </td>
              </tr>
              <tr>
                <td className="text-muted">
                  <div className="d-flex align-items-center">
                    Phone
                  </div>
                </td>
                <td className="fw-bolder text-end">{customer?.phone}</td>
              </tr>
              <tr>
                <td className="text-muted">
                  <div className="d-flex align-items-center">
                    ID number
                  </div>
                </td>
                <td className="fw-bolder text-end">{customer?.personal_number}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}